import { render } from "./Unlock.vue?vue&type=template&id=1ce2999c"
const script = {}

import exportComponent from "/Users/theimer/Developer/laravel/nova-medialibrary-field/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__